define(['jquery', 'common', 'erv_tracking'],
	function($, Common, ERVTracking) {
		var BookingStepThree = function() {
			var self = this;

			self.$ervBody = $('#erv-body');
			self.common = new Common();
			self.tracking = new ERVTracking();

			self.addOnsSubmitWithTracking = function($form) {
				var details = '';
				var sum = 0.0;

				var $inputs = $form.find('[name$=".AddOnsIds"]:checked');
				var $options = $form.find('[name$=".CancellationId"] option:selected');

				$inputs.each(function () {
					details += $(this).parent().find('label [data-js="addonname"]').text() + ', ';
					sum += Number($(this).attr('data-price'));
				});

				$options.each(function () {
					details += 'Cancellation ' + $(this).val() + ', ';
					sum += Number($(this).attr('data-price'));
				});

				self.common.forms.activateLoading($form, false)

				self.tracking.trackEvent('Booking', 'AddedUpgradesInPaymentStep', 'Upgraded insurance with: ' + details, sum, function () {
					$form[0].submit();
				});
			}

			self.initEventhandlers = function () {
				self.$ervBody.find('form#bookingpaymentform').on('submit', function (e) {
					var $form = $(this);
					if ($form.find('.addons [data-is-dirrty="true"]').length == 0 || $form.attr('action').indexOf('UpdateAddons') >= 0) {
						return;
					}

					e.preventDefault();
					self.common.forms.deactivateLoading($form.find('.btn.loading'));

					self.common.framework.popup.openPopup(
						'#confirm-upgrades-lightbox',
						{
							elementParse: function (item) {
								$(item.src).removeClass('hide');
							}
						},
						true, true
					);
				});

				self.$ervBody.find('#confirm-upgrades-lightbox').find('[data-js]').on('click', function (e) {
					var $popupButton = $(this),
						$form = self.$ervBody.find('form#bookingpaymentform');

					if($form.length > 0) {
						e.preventDefault();
						$popupButton.data('js') === 'ok' ? $form.attr('action', $form.data('actionbase') + 'UpdateAddons') : $form.attr('action', $form.data('actionbase'));

						self.common.forms.activateLoading($(this), false)

						$form[0].submit();
					}
				});

				self.$ervBody.find('#paymentsaveaddons').on('click', function (e) {
					e.preventDefault(); 

					var $form = $(this).closest('form');
					$form.data('validator').cancelSubmit = true;

					$form.attr('action', $form.data('actionbase') + 'UpdateAddons');

					self.addOnsSubmitWithTracking($form);
				});

				self.$ervBody.find('[data-js="trigger-approve-small"]').on('click', function (e) {
					e.preventDefault();
					var $link = $(this),
						$parent = $link.parents('.approve-small-parent');

					if ($parent.hasClass('closed')) {
						$parent.removeClass('closed').addClass('open');
						$link.text($link.data('less'));
					} else if ($parent.hasClass('open')) {
						$parent.removeClass('open').addClass('closed');
						$link.text($link.data('more'));
					}

					self.tracking.trackEvent('Booking', 'TermsAndConditionExpandCollapse', $link.text());
				});
			}

			self.initPaymentOrder = function () {
				var $mobilePayLabel = self.$ervBody.find('[for=Input_PaymentMethod_MobilePayment]');

				if (self.common.framework.checks.isMobileDevice() && $mobilePayLabel.length) {
					$mobilePayLabel.click();
					$mobilePayLabel.parents('li').prependTo('[data-js="paymentmethod"]');
				}
			}
		};

		BookingStepThree.prototype.init = function() {
			var self = this;
			self.initEventhandlers();
			var $apsisForm = self.$ervBody.find('#SubscriberForm');
			var cookieName = self.common.framework.settings.CookieStrings.SentToApsis;
			if ($apsisForm.length === 1 && self.common.framework.cookies.get(cookieName) == undefined) {

				$apsisForm.find('#apsisSubmit').click();
				self.common.framework.cookies.set(cookieName, true, { expires: self.neverExpires, path: '/' });
			}

			self.$ervBody.find('form#bookingpaymentform .addons').dirrty({ preventLeaving: false });

			$('body').on('bookingjsloaded', function () {
				self.initPaymentOrder();
			});
		}

		return BookingStepThree;
	});